module.exports = __webpack_public_path__ + "img/72.a794af64.jpg";